'use client'

import dynamic from 'next/dynamic'

import GuestConnectBtn from '@/app/[locale]/components/ConnectBtn/GuestConnectBtn'
import { useClientProvidersReady } from '@/providers/ClientProvidersReadyContext'

const ConnectBtn = dynamic(
  () => import('@/app/[locale]/components/ConnectBtn'),
  {
    ssr: false,
    // Keep the SSR/light guest CTA visible while the heavy button chunk loads —
    // avoids empty → button flicker in the header.
    loading: () => <GuestConnectBtn />
  }
)

export default function HeaderConnectSlot() {
  const providersReady = useClientProvidersReady()

  if (!providersReady) {
    return <GuestConnectBtn />
  }

  return <ConnectBtn />
}
